/**
 * Validates a Brazilian CPF (Cadastro de Pessoas Físicas) number.
 *
 * @param {string} value - The CPF number to validate as a string.
 * @returns {boolean} Returns true if the provided CPF is valid, otherwise returns false.
 */
export const validateCPF = (value: string): boolean => {
	if (!value) {
		return false;
	}

	// Sanitize input
	const sanitizedValue = value?.replace(/[.-]/g, '');

	if (!/^\d{11}$/.test(sanitizedValue)) {
		return false;
	}

	if (/^(\d)\1{10}$/.test(sanitizedValue)) {
		return false;
	}

	const cpf = sanitizedValue.split('').map(Number);

	const calculateDigit = (cpfPart: number[]) => {
		const sum = cpfPart.reduce(
			(acc, curr, index) => acc + curr * (cpfPart.length + 1 - index),
			0,
		);
		const digit = (sum * 10) % 11;
		return digit === 10 ? 0 : digit;
	};

	if (calculateDigit(cpf.slice(0, 9)) !== cpf[9]) {
		return false;
	}

	if (calculateDigit(cpf.slice(0, 10)) !== cpf[10]) {
		return false;
	}

	return true;
};
